// src/security/papeis.js

/**
 * Papéis do usuário a partir do token do Keycloak, lidos do MESMO jeito que o
 * crm-back lê (KeycloakJwtAuthenticationConverter): papéis do realm mais os de
 * cada client, em maiúsculas. Assim a tela e a API concordam sobre quem é quem.
 */
export function papeisDoToken(token) {
    const papeis = new Set();
    const adicionar = (lista) => {
        if (!Array.isArray(lista)) return;
        lista.forEach((p) => {
            const papel = String(p ?? '').trim().toUpperCase();
            if (papel) papeis.add(papel);
        });
    };

    adicionar(token?.realm_access?.roles);
    Object.values(token?.resource_access || {}).forEach((client) =>
        adicionar(client?.roles)
    );

    return [...papeis];
}
